import { dseds } from "@ucl/shared-component-foundations";

export const thankYouPageConfig = {
  optedIn: {
    translationKey: "optedIn",
    iconType: "optIn",
    iconColour: "success",
    showBackButton: true,
  },
  optedOut: {
    translationKey: "optedOut",
    iconType: "optOut",
    iconColour: dseds.semanticMode1.color.icon.onLight.interactive.value,
    showBackButton: true,
  },
  documentsSubmitted: {
    translationKey: "documentsSubmitted",
    iconType: "circleTickFilled",
    iconColour: "success",
    showBackButton: true,
  },
  contactDetailsUpdatedEmail: {
    translationKey: "contactDetailsUpdatedEmail",
    iconType: "circleTickFilled",
    iconColour: "success",
    showBackButton: true,
  },
  contactDetailsUpdatedPost: {
    translationKey: "contactDetailsUpdatedPost",
    iconType: "circleTickFilled",
    iconColour: "success",
    showBackButton: true,
  },
  challengeSubmitted: {
    translationKey: "challengeSubmitted",
    iconType: "circleTickFilled",
    iconColour: "success",
    showBackButton: true,
  },
  objectionSubmitted: {
    translationKey: "objectionSubmitted",
    iconType: "circleTickFilled",
    iconColour: "success",
    showBackButton: true,
  },
  noRedressAccepted: {
    translationKey: "noRedressAccepted",
    iconType: "circleTickFilled",
    iconColour: "success",
    showBackButton: true,
  },
  redressAccepted: {
    translationKey: "redressAccepted",
    iconType: "circleTickFilled",
    iconColour: "success",
    showBackButton: true,
  },
  bankDetailsNameValidationFailed: {
    translationKey: "bankDetailsNameValidationFailed",
    iconType: "phone",
    iconColour: dseds.semanticMode1.color.icon.onLight.interactive.value,
    showBackButton: false,
    showCallButton: true,
    showEmailButton: true,
  },
} as const;
